import { createContext } from 'react';
import { useAuthContext } from './require-auth';

export interface IUser {
  accessToken: string;
  refreshToken: string;
  expiresEpoch: number;
  expiresInSec: number;
  idToken: string;
  tokenType: string;
  user: {
    uuid?: string | null;
    username?: string | null;
    firstName?: string;
    lastName?: string;
  };
}

export interface AuthUser {
  user: IUser | null;
  setSignedInUser(user: IUser | null): Promise<void>;
  resetUser(): void;
  isUserIdle: boolean;
  setIsUserIdle(isUserIdle: boolean): void;
}

const defaultAuthUser: AuthUser = {
  user: null,
  setSignedInUser: (user: IUser | null) => Promise.resolve(),
  resetUser: () => {},
  setIsUserIdle: () => {},
  isUserIdle: false,
};

const AuthContext = createContext<AuthUser>(defaultAuthUser);

export const useCurrentUser = () => {
  const { user } = useAuthContext();
  if (!user) {
    throw new Error('User is not signed in');
  }
  return user?.user;
};

export const useCurrentUserUuid = () => {
  let { uuid } = useCurrentUser();
  if (!uuid) {
    uuid = localStorage.getItem('currentUserId');
  }
  return uuid;
};

export default AuthContext;
